import { render, staticRenderFns } from "./ServerDuration.vue?vue&type=template&id=10d20714"
import script from "./ServerDuration.vue?vue&type=script&lang=js"
export * from "./ServerDuration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports